// src/components/ComboCard.jsx
import React from "react";
import StarRating from "../components/StarRating"; // Assuming you have a StarRating component

const ComboCard = ({ combo }) => {
  if (!combo) return null;

  return (
    <div className="mt-2">
      <img
        src={`/${combo.image}`}
        alt={combo.title}
        className="mx-auto mb-4 rounded-lg"
      />
      <h3 className="text-sm sm:text-base font-semibold text-gray-900 truncate">
        {combo.title}
      </h3>
      <StarRating rating={combo.rating || 5} />
      <div className="mb-2">
        <div className="space-y-1 text-sm font-medium">
          <div className="text-gray-500">
            Price: <span className="line-through">{combo.mrp}</span>{" "}
            <span className="text-red-700 text-base">{combo.price}</span>
          </div>
          <div className="text-black font-medium">Free Delivery</div>
        </div>
      </div>
      <a
        href={`/combos/${combo.str}`}
        className="mt-4 inline-block px-4 py-2 w-full bg-black text-white text-xs font-medium rounded hover:bg-gray-800 transition"
      >
        View Details
      </a>
    </div>
  );
};

export default ComboCard;
